/**
 * OVERRIDE Navigation.jsx
 */

import Navigation from '../../../../components/Navigation/Navigation';

export default Navigation;